module.exports = __webpack_public_path__ + "static/img/l6.1049962a.png";